import _get from 'lodash/get';
import OrderSearchDuck from 'ducks/order-search-duck';

import { fetchWithOption } from './fetch-helper';
import { getOrderGuidsEndpoint } from '../endpoints/order-search-endpoints';

export const mappingResponseWithOrderIDs = (orderIDs, data) => {
  const mappingResponse = _get(data, 'mapping', []);
  const mapping = {};
  orderIDs.forEach(orderID => {
    mapping[orderID] = _get(
      mappingResponse.find(resp => orderID === resp.orderID),
      'orderGuid',
      '',
    );
  });
  return mapping;
};

export const onFetchSuccess = orderIDs => data => dispatch => {
  const mapping = mappingResponseWithOrderIDs(orderIDs, data);
  dispatch(OrderSearchDuck.creators.setOrderIDMapping(mapping));
  dispatch(
    OrderSearchDuck.creators.setSelectedOrder({
      orderID: orderIDs[0],
      orderGUID: mapping[orderIDs[0]],
    }),
  );
};

export const onFetchError = orderIDs => data => dispatch => {
  const mapping = mappingResponseWithOrderIDs(orderIDs, data);
  dispatch(OrderSearchDuck.creators.setOrderIDMapping(mapping));
  dispatch(
    OrderSearchDuck.creators.setSelectedOrder({
      orderID: orderIDs[0],
      orderGUID: mapping[orderIDs[0]],
    }),
  );
};

export const fetchOrderMapping = orderIDs =>
  fetchWithOption(
    getOrderGuidsEndpoint(),
    {
      method: 'POST',
      body: {
        OrderIDs: orderIDs,
      },
      mode: 'cors',
    },
    {
      success: onFetchSuccess(orderIDs),
      error: onFetchError(orderIDs),
    },
  );

export default {};
